<template>
    <TMobileServices
        v-model="sortingValue"
        :footer-button-text="footerButtonText"
        :active-buttons="indexPanelActiveButtons"
        :current-letter-index-panel="currentLetterIndexPanel"
        :sorting-buttons="sortingPanelButtons"
        :is-footer="false"
        :is-controls="false"
        sorting-panel
        class="o-mobile-services"
        color="#E25046"
        :theme="'back'"
        @onFooterButton="handleClickBack"
    >
        <template #header>
            <OMobileSearchHeader
                :title="$t('ui.service-category')"
                subtitle=""
                :_subtitle="$t('ui.service-category.description')"
            >
                <template #rightIcon>
                    <div class="o-mobile-services-header-icons">
                        <svg-icon
                            original
                            name="icons/m-search-setting"
                            class="o-mobile-services-header-icons__setting"
                        />
                        <img
                            v-if="categoryIcon && !isLandscape"
                            :src="categoryIcon"
                            alt="logo image"
                            class="o-mobile-services-header-icons__search"
                        />
                        <svg-icon
                            v-else
                            original
                            name="icons/search_mobile"
                            class="o-mobile-services-header-icons__search"
                        />
                    </div>
                </template>
            </OMobileSearchHeader>
            <div 
                class="m-header__line"
                :style="`background-color: ${seviceColor}`"
            />
        </template>
        <template #container>
            <RecycleScroller
                #default="{ item, index }"
                :items="items"
                :item-size="isLandscape ? 38 : 67"
                class="mobile-services__scroller"
            >
                <OWItemSearchTile
                    v-if="t(item, 'type') === 'tenant' || t(item, 'type') === 'service'"
                    :item="item"
                    @onClick="handleTileClick"
                    :style="`background-color: ${index%2 == 0|| index == 0 ? colorConvert(seviceColor) : '#fff'};`"
                />
                <OWItemSearchCategoryTile
                    v-else
                    :item="item"
                    :style="`background-color: ${index%2 == 0|| index == 0 ? colorConvert(seviceColor) : '#fff'};`"
                    :is-service="true"
                    @onClick="handleTileClick"
                />
            </RecycleScroller>
        </template>
    </TMobileServices>
</template>

<script>
import uniq from "lodash/uniq";
    
import {
    mapState,
    mapGetters
} from 'vuex';

import TMobileServices from '../../templates/t-mobile-items/t-mobile-items';
import OWItemSearchTile from '../../organisms/o-w-item-search-tile/o-w-item-search-tile';
import OMobileSearchHeader from '../../organisms/o-mobile-search-header/o-mobile-search-header';
import OWItemSearchCategoryTile from '../../organisms/o-w-item-search-category-tile/o-w-item-search-category-tile';

import {colorConvert} from '../../../utils/helpers/colorConvert';

import {
    MOBILE_ROOT,
    MOBILE_GUIDE,
    MOBILE_SERVICE,
    MOBILE_SERVICES
} from '../../../utils/constants/pages';

export default {
    name: 'OMobileServices',
    components: {
        TMobileServices,
        OWItemSearchTile,
        OMobileSearchHeader,
        OWItemSearchCategoryTile
    },
    data() {
        return {
            renderItems: 10,
            sortingValue: 'All',
            currentLetterIndexPanel: 'a',
            colorConvert: colorConvert
        }
    },
    props: {
        /**
         * Use in case we need to exclude some item from tenants list.
         * For example: items on searchbar on guide screen
         */
        filteredByItem: {
            type: Number,
            default: null
        },
        isCloseButtonShow: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            isLandscape: state => state.landscape,
        }),
        ...mapGetters([
            't',
            'getObject',
            'getServiceCategoriesAZ'
        ]),
        service() {
            return this.getObject(this.filteredByItem);
        },
        items() {
            const items = [...this.getServiceCategoriesAZ];
            if (this.filteredByItem && this.service.type === 'service' || this.filteredByItem && this.service.lists['service_categories']) {
                const filtered = [];
                items.forEach(item => {
                    if (this.service.lists.categories ? this.service.lists.categories.includes(item.id) : this.service.lists['service_categories'].includes(item.id)) {
                        if (item.objectsCount > 1) {
                            item.objectsCount -= 1;
                            filtered.push(item);
                        }
                    } else {
                        filtered.push(item);
                    }
                });
                return this.filteredItemsBySortingValue(filtered);
            } else {
                return this.filteredItemsBySortingValue(items);
            }
        },
        footerButtonText() {
            return this.$route.name === MOBILE_SERVICES ? this.$t('ui.close') : this.$t('ui.back')
        },
        /**
         * Detects active letters for index panel
         * * @returns {object|Array}
         */
        indexPanelActiveButtons() {
            return uniq(this.items.map((item) => {
                return this.t(item, "name").charAt(0).toLowerCase();
            }));
        },
        /**
         * Detects what letters will render in sorting panel
         * @returns {object|Array}
         */
        sortingPanelButtons() {
            return uniq(this.getServiceCategoriesAZ.map((item) => {
                return this.t(item, "name").charAt(0);
            }));
        },
        seviceColor(){
            return this.t(this.service, "color") || '#f0f0f0';
        },
        categoryIcon() {
            return this.t(this.service, "icon") || false
        }
    },
    methods: {
        filteredItemsBySortingValue(data) {
            if (this.sortingValue && this.sortingValue !== 'All') {
                const valueLength = this.sortingValue.length;
                const selectedItems = [];
                for (let i = 0; i < valueLength; i++) {
                    selectedItems.push(...data.filter(name => {
                        const firstLetter = this.t(name, "name").charAt(0);
                        return firstLetter === this.sortingValue.charAt(i);
                    }));
                }
                return selectedItems;
            }
            return data;
        },
        handleTileClick(data) {
            switch (this.$route.name) {
                case MOBILE_SERVICES:
                    this.redirectToService(data);
                    break;
                case MOBILE_GUIDE:
                    this.changeExtremePoint(data);
                    break;
                default:
                    break;
            }
        },
        handleClose() {
            this.redirectToHome();
        },
        redirectToService(data) {
            const params = {
                name: MOBILE_SERVICE,
                query: {
                    id: data.id
                }
            };
            this.$router.push(params);
        },
        handleClickBack() {
            if (this.$route.name === MOBILE_SERVICES) this.redirectToHome();
            else this.emitClickBack();
        },
        emitClickBack() {
            this.$emit('onClickBack', true);
        },
        redirectToHome() {
            const params = {
                name: MOBILE_ROOT
            };
            this.$router.push(params);
        },
        changeExtremePoint(data) {
            this.$emit('onServiceData', data);
        }
    }
}

</script>

<style lang="scss">
@import "o-mobile-services";
</style>